export const DatevEntryTypesMapping: {
  [key: string]: number;
} = {
  datev_trns: 6,
  datev_shipment: 7,
  datev_commingling: 8,
  datev_trns_local: 10,
  datev_trns_netto: 11,
  datev_trns_vat: 12,
};

export const FiltersLabelsDE: {
  [key: number]: string;
} = {
  6: 'Umsätze',
  10: 'Lokale Umsätze',
  11: 'OSS Netto',
  12: 'OSS VAT',
  7: 'Warenverbringungen',
  8: 'Commingling',
};
export const FiltersLabelsEN: {
  [key: number]: string;
} = {
  6: 'Turnover',
  10: 'Local Turnover',
  11: 'OSS Net',
  12: 'OSS VAT',
  7: 'Warenverbringungen',
  8: 'Commingling',
};

export const DatevFileMappingEN: {
  [key: string]: string;
} = {
  datev_trns: 'Turnover',
  datev_trns_local: 'Local Turnover',
  datev_trns_netto: 'OSS Net',
  datev_trns_vat: 'OSS VAT',
  datev_shipment: 'Warenverbringungen',
  datev_commingling: 'Commingling',
};
export const DatevFileMappingDE: {
  [key: string]: string;
} = {
  datev_trns: 'Umsätze',
  datev_trns_local: 'Lokale Umsätze',
  datev_trns_netto: 'OSS Netto',
  datev_trns_vat: 'OSS USt',
  datev_shipment: 'Warenverbringungen',
  datev_commingling: 'Commingling',
};
